import { borderBottom } from "@material-ui/system";

/* Response Time CSS */

export default theme => ({
    rootClassName:{
        width:"100%"
    },
    circular:{
      color:"white",
    },
    print: {
        border:"1px solid"    
        },
    
});

